<template lang="pug">
app-text-input(
  v-bind="attrs"
  v-on="listeners"
)
  template(
    v-for="(_, name) in $scopedSlots"
    v-slot:[name]="data"
  )
    slot(
      :name="name"
      v-bind="data"
    )
  template(
    v-for="(_, name) in $slots"
    :slot="name"
  )
    slot(:name="name")
</template>

<script>
export default {
  name: 'PasswordInput',
  components: {},
  props: {
    iconOn: {
      type: String,
      default: '$ieye-close',
    },
    iconOff: {
      type: String,
      default: '$ieye-open',
    },
  },
  data() {
    return {
      showRawPassword: false,
    };
  },
  computed: {
    attrs() {
      const { type, ...rest } = this.$attrs;
      const passwordAttrs = this.showRawPassword ? this.showRawPasswordAttrs : this.hideRawPasswordAttrs;

      return {
        ...passwordAttrs,
        ...rest,
      };
    },
    listeners() {
      return {
        ...this.$listeners,
        'click:append': this.onClickAppend,
      };
    },
    showRawPasswordAttrs() {
      return {
        type: 'text',
        'append-icon': this.iconOn,
      };
    },
    hideRawPasswordAttrs() {
      return {
        type: 'password',
        'append-icon': this.iconOff,
      };
    },
  },
  watch: {},
  created() {},
  methods: {
    onClickAppend() {
      this.showRawPassword = !this.showRawPassword;
      this.$emit('click:append');
    },
  },
};
</script>
